var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeautyWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2852 0.378418C53.1152 0.288418 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745117 22.6384 0.745117 50.2484C0.745117 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2452 2.18842 54.2852 0.378418ZM90.8152 68.4284C83.8752 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74512 74.5084 6.74512 50.2484C6.74512 42.7784 8.61504 35.7484 11.915 29.5784C19.325 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3352 62.8884 90.8152 68.4284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.425 29.1884C69.5051 27.9584 69.495 26.7084 69.655 25.4684C69.805 24.0984 70.065 22.7284 70.415 21.3984C70.535 21.0084 71.0052 19.1084 71.1152 18.6584C65.1352 18.1784 58.9252 18.3384 53.3052 20.6884C46.2152 23.5784 41.385 29.8684 42.415 37.7384C42.585 39.0184 42.8952 40.3384 43.3452 41.5784C42.8852 42.7184 42.5151 43.9184 42.2151 45.1484C40.6851 43.0584 39.2052 40.7584 38.0952 38.1584C36.0252 33.3284 35.6451 28.4484 36.925 23.2384C38.345 17.5084 41.6051 14.4784 42.2451 13.9284C42.3651 13.8284 42.3852 13.6484 42.2952 13.5184C42.2052 13.3884 42.025 13.3484 41.885 13.4284C36.925 16.3884 33.315 19.3684 30.875 22.5284C28.605 25.4684 27.3352 29.2184 27.2952 33.0884C27.2652 36.4384 26.7151 38.8184 25.7351 39.7984L20.0251 45.8784L20.0051 45.8984C19.7251 46.2584 19.6452 46.7384 19.7952 47.1684C19.9452 47.6084 20.2951 47.9384 20.7451 48.0484C23.4851 48.7584 23.9151 49.1584 23.9851 49.2484C23.9751 49.5284 23.7552 50.3084 23.5452 51.0684C23.1552 52.4684 22.7252 54.0584 22.8352 54.7784C23.0552 56.2184 24.0451 56.5484 25.2051 56.6184C24.6651 56.9184 24.1951 57.2984 23.9451 57.6584C22.8851 59.1884 24.2251 60.3384 25.0151 61.0184C25.2551 61.2284 25.625 61.5484 25.655 61.6784C24.775 62.5584 24.9752 65.3984 25.3152 66.1984C26.4652 68.8384 29.8652 69.2284 31.7952 69.2284C36.1852 69.2284 40.8351 71.3284 41.2351 75.3284C41.6051 79.0784 40.5051 83.1184 38.2151 86.4384C38.1151 86.5884 38.1151 86.7884 38.2251 86.9284C38.3051 87.0384 38.4252 87.0884 38.5552 87.0884C38.6052 87.0884 38.6551 87.0884 38.7051 87.0584C40.6451 86.3384 50.4851 82.3184 53.2151 73.3984C55.1351 67.1284 53.175 59.8584 47.385 51.7884C46.685 50.8184 45.8651 49.7884 44.9951 48.6984C44.9751 48.6784 44.9651 48.6584 44.9451 48.6384C45.1351 48.0784 45.2352 47.4784 45.3052 46.8884C45.4452 45.9084 45.6352 44.9384 45.8652 43.9784C49.2452 45.1084 53.2651 44.9284 56.6851 44.4784C61.8951 43.8984 65.7451 40.4884 67.7651 35.7884C68.6851 33.6784 69.2451 31.4384 69.4351 29.1484L69.425 29.1884ZM66.4751 22.4484C66.1551 24.2084 65.9551 25.9884 65.9651 27.7884C65.9651 28.1384 65.9651 28.5984 65.9451 28.9484C65.5651 34.8684 62.4951 40.8584 56.2251 41.8484C53.6551 42.3584 51.005 42.6584 48.405 42.4784C47.715 42.4184 47.0252 42.3384 46.3552 42.1884C46.9152 40.4384 47.655 38.7484 48.635 37.1684C51.125 33.0984 54.9951 29.9984 58.6851 26.9684C56.4651 28.0284 54.2951 29.2184 52.2351 30.6284C48.9251 32.8284 46.3552 35.6684 44.5552 38.9884C44.5352 38.8984 44.5251 38.8084 44.5051 38.7284C44.4851 38.5284 44.415 38.0384 44.395 37.8384C43.655 30.8584 47.9652 25.6384 54.3552 23.3784C57.3652 22.2884 60.6052 21.8784 63.8052 21.8484C64.7252 21.8484 65.6452 21.8884 66.5752 21.9484C66.5452 22.1184 66.5051 22.2884 66.4751 22.4484Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.665 49.7984L71.5552 51.0084C71.2952 51.2984 65.0652 58.1584 65.0652 63.6484C65.0652 67.8384 68.475 71.2484 72.665 71.2484C76.855 71.2484 80.2651 67.8384 80.2651 63.6484C80.2651 58.1484 74.0451 51.2984 73.7751 51.0084L72.665 49.7984ZM72.665 68.2384C70.135 68.2384 68.0652 66.1784 68.0652 63.6384C68.0652 60.7184 70.795 56.6684 72.665 54.3284C74.535 56.6684 77.2651 60.7184 77.2651 63.6384C77.2651 66.1684 75.205 68.2384 72.665 68.2384Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1708",
    x: -0.0000186563,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1708",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1708"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1708",
    result: "effect3_innerShadow_4857_1708"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyWellness);
export default __webpack_public_path__ + "static/media/BeautyWellness.ee909f9dd7a118e3101ffc1c9ce8ad25.svg";
export { ForwardRef as ReactComponent };